export default __webpack_public_path__ + "static/GovernanceLayer@2x-92aed7e78b24279a169abaae4a2afa88.png";